import Illustration from './Illustration';
import { ILLU_COLOR } from './ScopeIllustration';
import illuRevisionEspacee from '../../assets/illustrations/fonctionnalites/revision-espacee.svg?raw';
import illuBilanCible from '../../assets/illustrations/bilan-cible.svg?raw';
import illuHistorique from '../../assets/illustrations/fonctionnalites/historique.svg?raw';
import illuDocument from '../../assets/illustrations/fonctionnalites/document.svg?raw';
import illuQuizParSujet from '../../assets/illustrations/fonctionnalites/quiz-par-sujet.svg?raw';
import illuValidationRecherche from '../../assets/illustrations/fonctionnalites/validation-recherche.svg?raw';
import illuSuiviProgression from '../../assets/illustrations/fonctionnalites/suivi-progression.svg?raw';
import illuGenerationIa from '../../assets/illustrations/fonctionnalites/generation-ia.svg?raw';
import illuCategories from '../../assets/illustrations/fonctionnalites/categories.svg?raw';
import illuRevisionsDuJour from '../../assets/illustrations/revisions-du-jour.svg?raw';
import illuConsolidation from '../../assets/illustrations/consolidation.svg?raw';
import illuQuizErreurs from '../../assets/illustrations/fonctionnalites/quiz-erreurs.svg?raw';
import illuCreationManuelle from '../../assets/illustrations/fonctionnalites/creation-manuelle.svg?raw';
import illuCodesQuiz from '../../assets/illustrations/fonctionnalites/codes-quiz.svg?raw';
import illuCleAcces from '../../assets/illustrations/fonctionnalites/cle-acces.svg?raw';
import illuMoteurComplet from '../../assets/illustrations/fonctionnalites/moteur-complet.svg?raw';
import illuEssaiGratuit from '../../assets/illustrations/fonctionnalites/essai-gratuit.svg?raw';
import illuTeleverser from '../../assets/illustrations/fonctionnalites/televerser.svg?raw';
import illuQuizLibre from '../../assets/illustrations/quiz-libre.svg?raw';
import illuEspaceFormateur from '../../assets/illustrations/menu/espace-formateur.svg?raw';
import illuRelectureHumaine from '../../assets/illustrations/fonctionnalites/relecture-humaine.svg?raw';
import illuMesAchats from '../../assets/illustrations/menu/mes-achats.svg?raw';
import illuActiverUnCode from '../../assets/illustrations/menu/activer-un-code.svg?raw';
import illuApprentissageGuide from '../../assets/illustrations/apprentissage-guide.svg?raw';
import illuConfigurationThematiques from '../../assets/illustrations/menu/configuration-thematiques.svg?raw';

import atsem from '../../assets/illustrations/fonctionnalites/atsem.svg?raw';

const CONTENT_ICONS = {
    'atsem': atsem,
    'calendar': illuRevisionEspacee,
    'target': illuBilanCible,
    'clock': illuHistorique,
    'file-text': illuDocument,
    'book-open': illuQuizParSujet,
    'award': illuValidationRecherche,
    'trending-up': illuSuiviProgression,
    'brain': illuGenerationIa,
    'layers': illuCategories,
    'calendar-clock': illuRevisionsDuJour,
    'refresh-cw': illuConsolidation,
    'clipboard-list': illuDocument,
    'list-checks': illuQuizErreurs,
    'pen-line': illuCreationManuelle,
    'bar-chart-3': illuSuiviProgression,
    'share-2': illuCodesQuiz,
    'key-round': illuCleAcces,
    'zap': illuMoteurComplet,
    'check-circle': illuEssaiGratuit,
    'upload': illuTeleverser,
    'graduation-cap': illuQuizLibre,
    'presentation': illuEspaceFormateur,
    'briefcase': illuDocument,
    'users': illuRelectureHumaine,
    'sparkles': illuGenerationIa,
    'gift': illuMesAchats,
    'ticket': illuActiverUnCode,
    'compass': illuApprentissageGuide,
    'settings': illuConfigurationThematiques,
    'check-square': illuQuizParSujet,
};

/** Dessins existants pour titres, cartes et états vides ; les commandes gardent leurs icônes. */
export default function ContentIllustration({ name, size = 40, color = ILLU_COLOR, className = '', style }) {
    return <span className={`content-illustration ${className}`} style={{ width: size, height: size, ...style }}><Illustration svg={CONTENT_ICONS[name] || CONTENT_ICONS['file-text']} color={color} /></span>;
}
